
var menuLess = {};
import genaration from '../../utils/classname';
export var menuClass = genaration(menuLess, 'menu');